<template>
  <div>
    <top-title
      name="积分乐园"
      style="margin: 20px 20px; min-width: 980px"
    ></top-title>

    <div class="integralEden">
      <div class="content" v-if="createStep == 1">
        <!-- 头部导航切换 -->
        <div class="navTab" v-if="allHide == true">
          <span
            class="tab"
            :class="{ active: tabActive == 1 }"
            @click="tabActive = 1"
            >创建活动</span
          >
          <span
            class="tab"
            :class="{ active: tabActive == 2 }"
            @click="tabActive = 2"
            >活动管理</span
          >
        </div>
        <!-- 创建活动 -->
        <ul class="activity" v-show="tabActive == 1">
          <li class="item">
            <div class="wrap">
              <img
                src="../../assets/images/integralCenter/dzp.png"
                class="img"
              />
              <div class="info">
                <span class="tit">大转盘抽奖</span>
                <span class="desc"
                  >缤纷有趣转盘抽奖，助力粉丝互动，多种奖品轮番吸引，中奖率自定义，成本自控，抽奖条件随心设置，提升客户参与度</span
                >
                <div class="btn">
                  <button v-zoom='{from:"忠诚度管理-积分乐园",name:"创建活动"}' @click="createActivity(1)">立即创建</button>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- 活动管理 -->
        <activity-manage
          v-if="tabActive == 2"
          :activityList="activityList"
          @changeData="changeData"
          @changeStatus="changeStatus"
          :actManag="actManag"
        ></activity-manage>
      </div>

      <!-- 创建活动步骤 -->
      <create-activity-step
        v-if="createStep == 2"
        @returnBack="returnBackChange"
        :activityData="activityData"
      ></create-activity-step>
    </div>
  </div>
</template>

<script>
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
import topTitle from "../../components/top-title";
import createActivityStep from "./create_activity_step";
import activityManage from "./activityManage";

export default {
  components: {
    topTitle,
    createActivityStep,
    activityManage,
  },
  data() {
    return {
      actManag: true,
      // 导航选中
      tabActive: 1,
      createStep: 1,
      activityData: null,
      // 活动列表
      activityList: [
        {
          name: "日历签到20200526 21:43:59",
          type: "日历签到",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 1,
        },
        {
          name: "浏览商品有礼20200526 21:43:59",
          type: "浏览商品有礼",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 2,
        },
        {
          name: "日历签到20200526 21:43:59",
          type: "日历签到",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 3,
        },
        {
          name: "浏览商品有礼20200526 21:43:59",
          type: "浏览商品有礼",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 1,
        },
        {
          name: "日历签到20200526 21:43:59",
          type: "日历签到",
          startTime: "2020-04-19 22：59：17",
          endTime: "2020-04-26 23：59：59",
          lastChangeTime: "2020-05-27 16:30:49",
          createShop: "小云旗舰店",
          status: 1,
        },
      ],
      allHide: true,
      activityUrl: "",
      venderId: "",
      idUrl1: "",
    };
  },
  created() {
    this.prefixQue();
  },
  mounted() {
    if(this.$route.query.tabAct == 3){
      this.tabActive = 2;
    }
  },
  methods: {
     //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
          this.idUrl1 =
            this.activityUrl +
            "/point-h5/" +
            "lottery_turntable" +
            "?venderId=" +
            this.venderId;
        })
        .catch((res) => {});
    },
    createActivity(type) {
      this.createStep = 2;
      switch (type) {
        case 1:
          this.activityData = {
            telImg: require("../../assets/images/integralCenter/night_m.png"),
            telCode: this.idUrl1,
          };
          break;
        case 2:
          this.activityData = {
            telImg: require("../../assets/images/integralCenter/night_m.png"),
            telCode: this.idUrl1,
          };
          break;
      }
    },
    returnBackChange() {
      this.createStep = 1;
    },
    changeData() {
      this.allHide = false;
    },
    changeStatus() {
      this.allHide = true;
    },
  },
};
</script>

<style scoped lang="scss">
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .content {
    min-height: 880px;
    margin: 20px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      span {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #fe4d45;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #fe4d45;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
        @keyframes opation {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 100%;
          }
        }
      }
    }
    .activity {
      display: flex;
      flex-wrap: wrap;
      align-content: baseline;
      box-sizing: border-box;
      padding: 30px 14px;
      list-style: none;
      height: 500px;
      min-width: 1366px;
      .item {
        flex: 1;
        max-width: 33.33%;
        min-width: 480px;
        box-sizing: border-box;
        padding: 0 14px;
        margin-bottom: 20px;
        .wrap {
          display: flex;
          box-sizing: border-box;
          padding: 0 15px;
          height: 200px;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          background-color: #fff;
          transition: all 0.2s;
          &:hover {
            box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
          }
          .img {
            flex-shrink: 0;
            height: 200px;
            margin-top: 14px;
          }
          .info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 30px 0 16px 0;
            .tit {
              font-size: 16px;
              color: #333;
            }
            .desc {
              margin: 15px 0;
              font-size: 14px;
              line-height: 24px;
              color: #333;
            }
            .btn {
              text-align: right;
              button {
                width: 94px;
                height: 32px;
                line-height: 28px;
                text-align: center;
                border-radius: 2px;
                border: 1px solid #fe4d45;
                color: #fe4d45;
                background-color: #fff;
                cursor: pointer;
                outline: none;
                transition: all 0.2s;
                &:hover {
                  background-color: #fe4d45;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>